/**
 * Cab Module – Landing page at /cabs.
 * Isolated from Flights/Activities. Uses existing auth & currency context.
 */

import React from "react";
import { Link } from "react-router-dom";
import { FaCar } from "react-icons/fa";

export default function CabPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-600 mb-6">
            <FaCar className="w-8 h-8" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Cab Booking
          </h1>
          <p className="text-gray-600 mb-8">
            Book airport pickup, airport drop, intracity or intercity cabs. Choose your route and get instant pricing.
          </p>
          <Link
            to="/cabs/search"
            className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            <FaCar className="w-5 h-5" />
            Book a Cab
          </Link>
        </div>
      </section>
    </div>
  );
}
